<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
    <path
      d="M0 11C0.0000407516 4.9249 4.92489 -2.15274e-07 11 -4.80825e-07C17.0751 3.93079e-05 22 4.92493 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM4.49121 11.3896C3.87835 11.9468 3.83275 12.8958 4.38965 13.5088C4.94681 14.1217 5.89579 14.1673 6.50879 13.6104L11 9.52734L15.4912 13.6104C16.1042 14.1673 17.0532 14.1217 17.6104 13.5088C18.1673 12.8958 18.1217 11.9468 17.5088 11.3896L12.6816 7.00195C11.7281 6.13512 10.2719 6.13512 9.31836 7.00195L4.49121 11.3896Z"
      fill="currentColor"
    />
  </svg>
</template>
